import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const DetailsList = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const DetailsItem = styled.div`
  flex-shrink: 0;

  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.small};
    margin-bottom: ${theme.space.mobile.nano};
  `}

  ${({ theme }) => media.sm`
    margin-right: ${theme.space.mobile.tiny};
  `}
`
